import { useContext, useEffect, useState } from 'react';
import { filter } from 'rxjs/operators';
import WindowEventContext from '../context/window-event-context';
import WindowStateContext from '../context/window-state-context';
import { handleKeyboardEvent, KeyboardControlKeys } from '../helpers/keyboard';
export default function useFocusableItem(windowId, itemId, settter) {
    var _a;
    var _b = useContext(WindowEventContext), _onFocusChange = _b._onFocusChange, _onFieldUpdate = _b._onFieldUpdate, eventStream$ = _b.eventStream$;
    var stateFromEnv = useContext(WindowStateContext);
    var _c = useState(false), isFocused = _c[0], setIsFocused = _c[1];
    useEffect(function () {
        var focusEle = stateFromEnv.focusedEle;
        if (focusEle &&
            focusEle.windowId === windowId &&
            focusEle.widgetId === itemId) {
            setIsFocused(true);
        }
        else {
            setIsFocused(false);
        }
    }, [stateFromEnv.focusedEle]);
    useEffect(function () {
        var subscription;
        if (isFocused) {
            subscription = eventStream$
                .pipe(filter(function (evt) { return evt.isKeyboardEvent; }))
                .subscribe(function (evt) {
                settter(function (val) {
                    var _a = handleKeyboardEvent(val, evt.payload), value = _a.value, control = _a.control;
                    if (control === KeyboardControlKeys.RETURN) {
                        _onFieldUpdate(itemId, val);
                        return val;
                    }
                    return value;
                });
            });
        }
        return function () {
            if (subscription && subscription.unsubscribe) {
                subscription.unsubscribe();
            }
        };
    }, [isFocused]);
    var onFocus = function (evt) {
        _onFocusChange(windowId, itemId);
    };
    return _a = {
            onFocus: onFocus
        },
        _a['data-focused'] = isFocused ? 'focused' : '',
        _a;
}
//# sourceMappingURL=useFocusableItem.js.map